<script>
import RawData from "@/components/widgets/raw-data.vue";
import Swal from "sweetalert2";
export default {
    name: 'RequestItems',
    components: { RawData },
    props: {
        items: {
            type: Array,
            required: true
        },
        withActions: {
            type: Boolean,
            default: false,
        },
        busy: Boolean,
        returned: {
            type: Boolean,
            default: false,
        },
        selectable: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        isSelectable() {
            return (this.selectable || !!this.$listeners['select-item']) && !this.withActions;
        },
        filtered(){
            let data = this.items;
            var total = this.currentPage * this.perPage;
            if(this.filter.trim() != "" && this.filter){
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            var currentData = data.slice(total - this.perPage, total);
            if (this.currentPage > 1 && currentData.length == 0) {
                total = (this.currentPage - 1) * this.perPage;
                currentData = data.slice(total - this.perPage, total);
            }
            return currentData;
        },
        rows(){
            let data = this.items;
            if (this.filter.trim() != "" && this.filter) {
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
                return data.length;
            }
            return data.length;
        }
    },
    data(){
        return {
            filter: '',
            perPage: 10,
            pageOptions: [10, 30, 50, 100],
            currentPage: 1,
        }
    },
    methods: {
        updateItem(item){
            this.$emit('updateItem', item)
        },
        deleteItem(item){
            this.$emit('deleteItem', item)
        },
        repostItem(item){
            Swal.fire({
                text: "Are you sure you want to repost this item?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#9b2ddb",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, repost it!",
            }).then((result) => {
                if (result.value) {
                    this.$emit('repostItem', item)
                }
            })
        },
        viewLog(item){
            this.$emit('viewLog', item)
        },
        getUnit(item){
            return typeof item.unit === 'string' ? item.unit : item.unit.unitName;
        },
        getItemCategory(item){
            return typeof item.itemCategory === 'string' ? item.itemCategory : item.itemCategory.name;
        },
        selectItem(item){
            if (this.isSelectable) {
                this.$emit('select-item', item);
            }
        },
    }
}
</script>
<template>
  <div>
    <div v-if="busy">Loading...</div>
    <div v-if="!busy && !items.length">No data found...</div>
    <div v-if="!busy && items.length">
        <div id="tickets-table_filter" class="dataTables_filter mb-2">
            <label class="d-inline-flex align-items-center mb-0">
                <b-form-input
                    autocomplete="off"
                    v-model="filter"
                    type="search"
                    placeholder="Search Item..."
                    class="form-control me-1"
                ></b-form-input>
                <b-form-select
                    class="form-select"
                    v-model="perPage"
                    :options="pageOptions"
                    style="width:70px;"
                ></b-form-select>
            </label>
        </div>
        <div v-for="(item, index) in filtered" :key="item.id">
            <div class="card mb-2 position-relative" :style="`z-index:${(items.length - index) + 100}`" :class="{'cursor-pointer': isSelectable}" @click="selectItem(item)">
                <RawData :data="item" v-if="$store.state.decrypt.isAdmin()" />
                <div class="card-body py-1 position-relative">
                    <div class="position-absolute" style="top:10px;right:10px;" v-if="withActions">
                        <b-dropdown
                            id="dropdown-dropleft"
                            right
                            variant="link"
                            toggle-class="text-decoration-none"
                            menu-class="dropdown-menu-end"
                            no-caret
                        >
                            <template #button-content>
                                <i class="fas fa-ellipsis-v"></i>
                            </template>
                            <b-dropdown-item
                                @click="updateItem(item)"
                                variant="secondary"
                                ><i class="mdi mdi-update font-size-18 me-1"></i
                                >Edit</b-dropdown-item
                            >
                            <b-dropdown-item
                                @click="deleteItem(item)"
                                variant="danger"
                                ><i
                                    class="mdi mdi-trash-can font-size-18 me-1"
                                ></i
                                >Delete</b-dropdown-item
                            >
                        </b-dropdown>
                    </div>
                    <div class="my-2" >
                        <h5 class="mb-0">{{item.itemName}}</h5>
                        <p class="mb-0 text-ellipsis" style="width:530px;">{{item.description}}</p>
                        <div class="d-flex justify-content-between">
                            <div>
                                <span class="badge bg-primary bg-soft me-1">{{getUnit(item)}}</span>
                                <span class="badge bg-primary bg-soft me-1">{{item.subType}}</span>
                                <span class="badge bg-primary bg-soft">{{getItemCategory(item)}}</span>
                            </div>
                            <div class="text-right">
                                <p class="mb-0 font-size-15 text-green font-weight-bold">{{formatCurrency(item.unitCost)}}</p>
                            </div>
                        </div>
                        <div>
                            Tech Rep: <span class="text-yellow"><span v-for="(x, xIndex) in item.technicalReviewUsers" :key="x.id">{{x.completeName}}<span v-if="xIndex != item.technicalReviewUsers.length - 1">, </span></span></span>
                        </div>
                        <div class="text-right" v-if="returned">
                            <hr class="my-2">
                            <div class="d-flex justify-content-between">
                                <a href="javascript:void(0);" class="me-2 text-green" @click="repostItem(item)">Repost</a>
                                <div>
                                    <a href="javascript:void(0);" class="me-2 text-secondary" @click="viewLog(item)">View Logs</a>
                                    <a href="javascript:void(0);" class="me-2 text-green" @click="updateItem(item)">Update</a>
                                    <a href="javascript:void(0);" class="text-danger" @click="deleteItem(item)">Remove</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="!filtered.length">Search not found...</div>
        <div class="text-center mt-4" v-if="filtered.length">
            <ul
                class="
                    pagination
                    justify-content-end
                "
            >
                <b-pagination
                    size="sm"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                ></b-pagination>
            </ul>
        </div>
    </div>
  </div>
</template>